<template>
  <div
    v-if="getFolders.length == 0"
    class="
      teams-main-container
      d-flex
      flex-column
      align-items-center
      justify-content-center
      relativeclass
    "
    :class="canEdit ? 'mt-3' : ''"
    :style="
      canEdit ? 'height: calc(100vh - 174px)' : 'height:calc(-225px + 100vh)'
    "
  >
    <img src="../../assets/New-imgs/teams-icons/teams_tree_empty.svg" alt="" />
    <div v-if="canEdit" class="teams-empty-container-font mt-3">
      There are no groups . Please go to list view and click on the
      “+&nbsp;&nbsp;Group” button to create new.
    </div>
    <div v-else-if="!canEdit" class="teams-empty-container-font mt-3">
      There is no data available. Go to Teams list view section and click on
      “+&nbsp;&nbsp;Group” to add folders.
    </div>
  </div>
  <div
    v-else
    class="teams-main-container d-flex relativeclass"
    :class="canEdit ? 'mt-3' : ''"
    :style="
      canEdit ? 'height: calc(100vh - 174px)' : 'height:calc(-225px + 100vh)'
    "
  >
    <div
      class="teams-grid-left-container"
      :style="
        canEdit ? 'height: calc(100vh - 203px)' : 'height: calc(100vh - 255px)'
      "
    >
      <div
        v-if="canEdit && roles.includes('PUT_TEAMS')"
        class="d-flex align-items-flex-start justify-content-end w-100 pointer"
      >
        <img
          @click="handleEdit"
          src="../../assets/New-imgs/teams-icons/teams-grid-edit-icon.svg"
          alt=""
        />
      </div>
      <div class="w-100" style="height: 90%">
        <div class="d-flex h-100 w-100">
          <organization-chart
            class="teams-hierarchical-view h-100 w-100"
            :datasource="organizationData"
          >
            <template slot-scope="{ nodeData }">
              <div
                :id="nodeData.id"
                @click="nodeData.id === '0' ? '' : handleNodeClick(nodeData)"
                class="hy-node d-flex"
                :class="
                  nodeData.id === '0'
                    ? 'justify-content-center'
                    : 'pointer justify-content-between'
                "
              >
                <div class="d-flex align-items-center h-100">
                  <div
                    class="
                      hy-folder
                      d-flex
                      align-items-center
                      justify-content-center
                    "
                  >
                    <img
                      class="hy-img"
                      src="../../assets/New-imgs/teams-icons/teams-big-folder.svg"
                      alt=""
                    />
                  </div>

                  <div class="ml-2">
                    {{ nodeData.title }}
                  </div>
                </div>
                <div v-if="nodeData.id !== '0'" class="hy-users">
                  <img
                    src="../../assets/New-imgs/teams-icons/teams-hy-small-user.svg"
                    alt=""
                  />
                  {{ nodeData.name }}
                </div>
              </div>
            </template>
          </organization-chart>
        </div>
      </div>
      <div class="d-flex m-0 align-items-center justify-content-end w-100 pt-1">
        <img
          v-if="!zoomedIn"
          src="../../assets/New-imgs/teams-icons/teams-grid-zoom-plus.svg"
          alt=""
          @click="zoomIn"
          class="pointer teams-zoom"
        />
        <img
          v-else-if="zoomedIn"
          src="../../assets/New-imgs/teams-icons/teams-grid-zoom-plus-clicked.svg"
          alt=""
          @click="zoomIn"
          class="pointer"
        />
        <img
          v-if="!zoomedOut"
          src="../../assets/New-imgs/teams-icons/teams-grid-zoom-minus.svg"
          alt=""
          @click="zoomOut"
          class="pointer teams-zoom"
        />
        <img
          v-else-if="zoomedOut"
          src="../../assets/New-imgs/teams-icons/teams-grid-zoom-minus-clicked.svg"
          alt=""
          @click="zoomOut"
          class="pointer"
        />
      </div>
    </div>
    <div
      class="teams-grid-right-container ml-3"
      :style="
        canEdit ? 'height: calc(100vh - 203px)' : 'height: calc(100vh - 255px)'
      "
    >
      <div class="relativeclass teams-innerInputField">
        <img
          class="teams-setImage"
          src="../../assets/img/search-bar-icon.svg"
          alt=""
        />

        <b-form-input
          placeholder="Search in Users"
          @update="getUsers"
          type="search"
          v-model.trim="searchUser"
          debounce="500"
          class="search-input"
        >
        </b-form-input>
      </div>

      <hr />
      <div class="d-flex mt-3 mb-2 justify-content-between align-items-center">
        <div class="teams-group-head">Users</div>
        <div
          v-if="
            !canEdit &&
            getActive !== '' &&
            currentFolder !== 'All Users' &&
            roles.includes('TAG_USER')
          "
          @click="openTagUsers = true"
          class="pointer"
        >
          <img
            src="../../assets/New-imgs/teams-icons/teams-grid-edit-icon.svg"
            alt=""
          />
        </div>
      </div>
      <b-overlay :show="userLoader" rounded="sm">
        <div
          class="teams-grid-container-height"
          id="teams-group-scrollbar"
          :style="
            canEdit
              ? 'height: calc(100vh - 320px)'
              : '    height: calc(100vh - 360px);'
          "
        >
          <div
            v-if="searchUser !== '' && tagUsers.length == 0"
            class="
              d-flex
              h-100
              flex-column
              align-items-center
              justify-content-center
            "
          >
            <img
              src="../../assets/New-imgs/teams-icons/teams-no-matching-results.svg"
              alt=""
            />
            <div class="teams-empty-container-font mt-3">
              No matching results for "{{ searchUser }}"
            </div>
          </div>
          <div
            v-else-if="searchUser == '' && tagUsers.length == 0 && !userLoader"
            class="
              d-flex
              h-100
              flex-column
              align-items-center
              justify-content-center
            "
          >
            <img
              v-if="getActive !== ''"
              src="../../assets/New-imgs/teams-icons/teams-no-tagged-users.svg"
              alt=""
            />
            <img
              v-else
              src="../../assets/New-imgs/teams-icons/teams-no-node-selected.svg"
              alt=""
            />
            <div
              v-if="getActive !== ''"
              class="teams-empty-container-font mt-3"
            >
              No tagged user(s)
            </div>
            <div v-else class="teams-empty-container-font mt-3">
              Select any group to view its users
            </div>
          </div>
          <div
            v-else
            class="teams-group-container d-flex align-items-center"
            v-for="(user, index) in tagUsers"
            :key="index"
            :class="index > 0 ? 'mt-2' : ''"
          >
            <div style="width: 70%">
              <div class="teams-addUser-container-head text-truncate">
                <span v-b-tooltip.hover="user.username">{{
                  user.username
                }}</span>
              </div>
              <div class="text-truncate w-100">
                <span
                  style="min-width: auto; max-width: 80%"
                  v-b-tooltip.hover="user.email"
                  class="
                    teams-addUser-container-subhead
                    text-truncate
                    d-inline-block
                  "
                  >{{ user.email }}</span
                >
              </div>
            </div>
            <div
              class="d-flex align-items-center justify-content-end"
              style="width: 30%"
            >
              <div
                class="teams-addUser-container-rightContent d-flex"
                v-b-tooltip.hover="user.roleName"
              >
                <div
                  v-if="user.roles.length > 0"
                  class="text-truncate"
                  style="min-width: auto; max-width: 70px"
                >
                  {{ user.roles[0] }}
                </div>
                <template v-if="user.roles.length > 1">
                  <div
                    v-if="user.roles.length === 1"
                    class="text-truncate"
                    style="min-width: auto; max-width: 100px"
                  >
                    {{ user.roles[0] }}
                  </div>
                  <div
                    v-else
                    class="text-truncate"
                    style="min-width: auto; max-width: 100px"
                  >
                    <span
                      v-for="(role, index) in user.roles.slice(1, 2)"
                      :key="index"
                    >
                      + {{ role }}
                    </span>
                    <span v-if="user.roles.length > 2"> + ...</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
      </b-overlay>
    </div>

    <!-- add user modal -->
    <TagUsers :openTagUsers="openTagUsers" @close-tag-users="onCloseTagUsers" />
  </div>
</template>

<script>
import TagUsers from "./modal/TagUsers.vue";
import { mapGetters } from "vuex";
import toast from "../../components/mixin/toast";
import { getFolderDetails } from "../../utils/apiFunctions";
import teamsMixin from "../../components/mixin/teamsMixin";
import OrganizationChart from "vue-organization-chart";
import "vue-organization-chart/dist/orgchart.css";

export default {
  name: "TeamsGridView",
  data() {
    return {
      tagUsers: [],
      searchUser: "",
      currentFolder: "",
      scale: 1,
      userLoader: false,
      zoomedIn: false,
      zoomedOut: false,
      openTagUsers: false,
    };
  },
  props: {
    canEdit: Boolean,
  },
  components: {
    OrganizationChart,
    TagUsers,
  },
  mixins: [toast, teamsMixin],
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("userVUEX", {
      getlicenseKey: "getlicenseKey",
    }),
    ...mapGetters("teamsVUEX", {
      getFolders: "getFolders",
    }),
    organizationData() {
      const allUsersFolder = this.getFolders.find(
        (folder) => folder.folderName === "All Users"
      );
      if (allUsersFolder) {
        return {
          id: allUsersFolder.folderID,
          name: allUsersFolder.users,
          title: allUsersFolder.folderName,
          children: this.transformData(),
        };
      } else {
        // If the All Users folder is not found, return a default parent node
        return {
          id: "0",
          name: "Main group",
          title: "Main group",
          children: this.transformData(),
        };
      }
    },
  },
  created() {
    if (this.getActive !== "") {
      this.getUsers();
    }
    this.getAllFolders();
  },
  mounted() {
    if (this.getActive !== "") {
      this.setStyle();
      document.getElementById(this.getActive).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    }
  },
  watch: {
    getActive(newValue, oldValue) {
      if (newValue !== oldValue && newValue !== "") {
        this.onCreateFolder();
      }
    },
  },
  methods: {
    async onCreateFolder() {
      await this.getAllFolders();
      const collection = document.getElementsByClassName("node");
      for (let i = 0; i < collection.length; i++) {
        collection[i].querySelector(".hy-node").style.background =
          "linear-gradient(82.92deg, rgba(178, 208, 238, 0.5) 0.29%, rgba(255, 255, 255, 0.5) 100.85%)";
        collection[i].querySelector(".hy-node").style.color = "#20639b";
      }
      this.setStyle();
      document.getElementById(this.getActive).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
    },
    onCloseTagUsers() {
      this.openTagUsers = false;
      this.setStyle();
      this.getAllFolders();
    },
    // GET ALL USERS FOR TAGGING
    async getUsers() {
      try {
        this.userLoader = true;
        let payload = {
          licenseKey: this.getlicenseKey,
          folderID: this.getActive,
          project: "recruitment",
          searchQuery: this.searchUser,
        };
        const response = await getFolderDetails(payload);
        if (response.status === 200) {
          if (response.data.data.content.userCuserCount != 0)
            this.tagUsers = response.data.data.content.users;
        }
      } catch (error) {
        this.errorModal("Something went wrong");
      } finally {
        this.userLoader = false;
      }
    },
    transformChildren(children) {
      return children.map((child) => ({
        id: child.folderID,
        name: child.users,
        title:
          child.folderName.length > 16
            ? child.folderName.substring(0, 16) + "..."
            : child.folderName,
        children: this.transformChildren(child.childFolders || []),
      }));
    },
    transformData() {
      // Filter out the "All Users" node from the data
      const filteredData = this.getFolders.filter(
        (item) => item.folderName !== "All Users"
      );

      // Transform the filtered data
      return filteredData.map((item) => ({
        id: item.folderID,
        name: item.users,
        title:
          item.folderName.length > 16
            ? item.folderName.substring(0, 16) + "..."
            : item.folderName,
        children: this.transformChildren(item.childFolders || []),
      }));
    },
    handleNodeClick(node) {
      this.currentFolder = node.title;
      this.$store.commit("teamsVUEX/setActive", node.id);

      const collection = document.getElementsByClassName("node");
      for (let i = 0; i < collection.length; i++) {
        collection[i].querySelector(".hy-node").style.background =
          "linear-gradient(82.92deg, rgba(178, 208, 238, 0.5) 0.29%, rgba(255, 255, 255, 0.5) 100.85%)";
        collection[i].querySelector(".hy-node").style.color = "#20639b";
      }

      this.setStyle();
    },
    setStyle() {
      if (this.getActive !== "") {
        document
          .getElementById(this.getActive)
          .querySelector(".hy-node").style.background = "#20639b";
        document
          .getElementById(this.getActive)
          .querySelector(".hy-node").style.color = "white";
        this.searchUser = "";
        this.getUsers();
      }
    },
    handleEdit() {
      this.getFolderDetails(this.getActive);
      this.$emit("switch-to-list-view");
    },
    zoomIn() {
      if (this.scale < 5.0) {
        this.zoomedOut = false;
        this.zoomedIn = true;
        this.scale = Math.min(this.scale + 0.1, 5.0); // Limit maximum scale to 5.0
        this.updateScale();
      }
    },
    zoomOut() {
      if (this.scale > 0.25) {
        this.zoomedIn = false;
        this.zoomedOut = true;
        this.scale = Math.max(this.scale - 0.1, 0.25); // Limit minimum scale to 0.25
        this.updateScale();
      }
    },
    updateScale() {
      const chartContainer = document.querySelector(".orgchart");

      chartContainer.style.zoom = this.scale;
      chartContainer.style.transformOrigin = "0 0";
    },
  },
};
</script>

<style>
/* General styles */
.orgchart-container::-webkit-scrollbar-thumb {
  box-shadow: none !important;
}

.teams-hierarchical-view .orgchart .node {
  width: 272px;
  height: 75px;
  margin-right: 15px;
  padding: 0;
  border: none;
}

.hy-node {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 12px;
  border-radius: 16px;
  background: linear-gradient(
    82.92deg,
    rgba(178, 208, 238, 0.5) 0.29%,
    rgba(255, 255, 255, 0.5) 100.85%
  );
  border: 1px solid rgba(140, 140, 140, 0.33);
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-size: 14px;
  color: var(--bluetheme);
  position: relative;
  z-index: 1;
}

.hy-node:hover {
  background: linear-gradient(98.4deg, #dfdfff 18.14%, var(--bg-white) 114.96%);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.17);
}

.teams-hierarchical-view .orgchart .node:hover {
  background-color: inherit;
}

.hy-folder {
  width: 36px;
  height: 36px;
  background: #e1eef7;
  border-radius: 23.125px;
}

.hy-img {
  position: relative;
  bottom: 1px;
}

.hy-users {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  gap: 1px;
  position: absolute;
  width: 39px;
  height: 51px;
  left: 217px;
  top: 12px;
  background: #e1eef7;
  border-radius: 6px;
  color: var(--bluetheme);
}

.teams-hierarchical-view .orgchart .lines .leftLine {
  border-left: 1px solid var(--bluetheme);
}

.teams-hierarchical-view .orgchart .lines .topLine {
  border-top: 2px solid var(--bluetheme);
}

.teams-hierarchical-view .orgchart .lines .rightLine {
  border-right: 1px solid var(--bluetheme);
}

.teams-hierarchical-view .orgchart .lines .downLine {
  background-color: var(--bluetheme);
}

.teams-hierarchical-view .orgchart .lines td[colspan="2"] .downLine {
  height: 0;
}

/* Remove background */
.teams-hierarchical-view .orgchart {
  background: none;
  border: none;
  padding: 0;
  height: 95%;
  width: 100%;
}

.orgchart-container {
  width: 100%;
  border: none;
  border-radius: none;
}

/* Zoom */
.teams-zoom {
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.25));
}
</style>
